<ng-template #toothTemplate let-tooth let-numberPosition="numberPosition">
	<rx-intuitive-art-tooth
		class="jaw-grid__tooth"
		[tooth]="tooth"
		[displayNumber]="getDisplayNumber(tooth)"
		[symbolId]="tooth.svgSymbolId"
		[numberPosition]="numberPosition"
		[chartReadOnly]="chartReadOnly"
		(toothClicked)="onToothClicked($event)"
	></rx-intuitive-art-tooth>
</ng-template>
<div class="jaw-diagram-grid">
	<ng-container *ngFor="let tooth of upperJaw | slice: 0 : upperJaw.length / 2; let i = index; trackBy: toothIdTrackBy">
		<div class="jaw-diagram-grid__tooth-cell jaw-diagram-grid__tooth-cell--upper" [style.grid-column]="i + 1">
			<ng-container *ngTemplateOutlet="toothTemplate; context: { $implicit: tooth, numberPosition: 'below' }"></ng-container>
		</div>
	</ng-container>
	<div class="jaw-diagram-grid__midline jaw-diagram-grid__midline--upper" aria-hidden="true"></div>
	<ng-container *ngFor="let tooth of upperJaw | slice: upperJaw.length / 2; let i = index; trackBy: toothIdTrackBy">
		<div class="jaw-diagram-grid__tooth-cell jaw-diagram-grid__tooth-cell--upper" [style.grid-column]="10 + i">
			<ng-container *ngTemplateOutlet="toothTemplate; context: { $implicit: tooth, numberPosition: 'below' }"></ng-container>
		</div>
	</ng-container>
	<hr class="jaw-diagram-grid__jaw-separator" />
	<ng-container *ngFor="let tooth of lowerJaw | slice: 0 : lowerJaw.length / 2; let i = index; trackBy: toothIdTrackBy">
		<div class="jaw-diagram-grid__tooth-cell jaw-diagram-grid__tooth-cell--lower" [style.grid-column]="i + 1">
			<ng-container *ngTemplateOutlet="toothTemplate; context: { $implicit: tooth, numberPosition: 'above' }"></ng-container>
		</div>
	</ng-container>
	<div class="jaw-diagram-grid__midline jaw-diagram-grid__midline--lower" aria-hidden="true"></div>
	<ng-container *ngFor="let tooth of lowerJaw | slice: lowerJaw.length / 2; let i = index; trackBy: toothIdTrackBy">
		<div class="jaw-diagram-grid__tooth-cell jaw-diagram-grid__tooth-cell--lower" [style.grid-column]="10 + i">
			<ng-container *ngTemplateOutlet="toothTemplate; context: { $implicit: tooth, numberPosition: 'above' }"></ng-container>
		</div>
	</ng-container>
</div>
